import { render, staticRenderFns } from "./contact-info.vue?vue&type=template&id=286b3ab4&scoped=true"
import script from "./contact-info.vue?vue&type=script&lang=js"
export * from "./contact-info.vue?vue&type=script&lang=js"
import style0 from "./contact-info.vue?vue&type=style&index=0&id=286b3ab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286b3ab4",
  null
  
)

export default component.exports